<div class="widget-card" 
     [ngClass]="getWidgetCardClasses()" 
     #widgetContainer
     *ngIf="widget">
  <!-- Header del Card -->
  <div class="widget-header">
    <div class="widget-title-section">
      <h5 class="widget-title">{{ widget.DisplayTitle }}</h5>
    </div>
    
  </div>

  <!-- Contenido del Widget -->
  <div class="widget-content">
    <app-connectivity-table
      [data]="widget">
    </app-connectivity-table>

    <!-- Status Summary Widget -->
    <app-status-summary 
      [data]="widget">
    </app-status-summary>

    <!-- XY Chart Widget -->
     <div > 
      <app-xy-chart 
      [data]="widget.XYChartData"
      [isShared]="false"
      [height]="widget.widgetDescriptor.Height">
      </app-xy-chart>
    </div>

    <cnm-pie-v2
      
      [datos]="widget.PieChartData"
      [widget]="widget.widgetDescriptor"
      [widgetId]="widget.WidgetID"
      [isShared]="false"
      [statusZoom]="false"
      [height]="widget.widgetDescriptor.Height"
      [showLegend]="true"
      [legendPosition]="'right'">
    </cnm-pie-v2>

    <div class="widget-error" *ngIf="!widget.WidgetTypeID || !isValidWidgetType(widget.WidgetTypeID)">
      <div class="error-content">
        <i class="fa-solid fa-exclamation-triangle"></i>
        <p>Tipo de widget no reconocido: {{ widget.WidgetID }}</p>
      </div>
    </div>
  </div>

</div>
